/**
 * Contains hardcoded list of subjects available when rendering the dropdown.
 */
export const subjects = {
    primarySchool: [
        "Billedkunst",
        "Biologi",
        "Børnehaveklassen",
        "Dansk",
        "Dansk som andetsprog",
        "Engelsk",
        "Fransk",
        "Fysik/kemi",
        "Geografi",
        "Håndværk og design",
        "Historie",
        "Idræt",
        "Kristendomskundskab",
        "Madkundskab",
        "Matematik",
        "Musik",
        "Natur/teknologi",
        "Naturfag",
        "Religion",
        "Samfundsfag",
        "Tysk",
        "Andet",
    ],
    highSchool: [
        "Almen sprogforståelse",
        "Billedkunst",
        "Biologi",
        "Bioteknologi",
        "Dansk",
        "Engelsk",
        "Filosofi",
        "Fransk",
        "Fysik",
        "Geografi",
        "Geovidenskab",
        "Historie",
        "Idehistorie",
        "Idræt",
        "Innovation",
        "Kemi",
        "Kulturfag",
        "Matematik",
        "Mediefag",
        "Naturgeografi",
        "Naturvidenskabeligt grundforløb",
        "Oldtidskundskab",
        "Psykologi",
        "Religion",
        "Samfundsfag",
        "Spansk",
        "Tysk",
        "Andet",
    ],
};
